var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrike3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#161616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.84447 14.168C12.0005 14.168 13.3585 13.034 13.3585 11.452C13.3585 10.01 12.0985 9.268 11.1885 9.184C12.1545 9.016 13.2185 8.288 13.2185 7.042C13.2185 5.474 11.8605 4.522 9.84447 4.522C8.29047 4.522 7.15647 5.152 6.44247 5.992L7.28247 7.014C7.95447 6.342 8.73847 5.978 9.69047 5.978C10.7405 5.978 11.5805 6.426 11.5805 7.294C11.5805 8.148 10.7545 8.526 9.66247 8.526C9.29847 8.526 8.75247 8.526 8.58447 8.512V9.982C8.72447 9.968 9.27047 9.968 9.66247 9.968C10.9925 9.968 11.7345 10.36 11.7345 11.284C11.7345 12.152 11.0205 12.712 9.78847 12.712C8.79447 12.712 7.80047 12.278 7.19847 11.578L6.31647 12.656C6.94647 13.496 8.17847 14.168 9.84447 14.168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrike3);
export default __webpack_public_path__ + "static/media/strike_3.21b202a7ac515e29d3e29cabc11c4366.svg";
export { ForwardRef as ReactComponent };